module.exports = __webpack_public_path__ + "static/media/step-2-footsteps.4de8c033.gif";